/**
 * @memberof generateSchema
 * */
export const filterOutExcludedFields = (allFields: Element[], excludedFieldNames?: string[]) => {
    if (excludedFieldNames === undefined) return allFields
    return allFields.filter((value: Element) => {
        const field = value as HTMLInputElement

        // if the field has no name, it should not be included anyway
        if (!field.name) { return false }

        const notExcluded = !excludedFieldNames?.filter((ex) => field.name === ex).length
        return notExcluded
    })
}
